import { ApiOutlined } from "@ant-design/icons";

import { ButtonDelete } from "../../../../../ButtonDelete";
import { useFlowNodes } from "views/Bots/NLP/application/Build/Flow/context";
import { handleIntegrationIntentNode } from "../../../../../utils/removeDataNode";

import "./IntegrationHeader.scss";

const IntegrationHeader = ({ title }) => {
  const { setNodes, setEdges, updateIntent, id } = useFlowNodes();
  return (
    <div className="integration-header">
      <div className="integration-icon">
        <ApiOutlined />
      </div>
      <div className="integration-title-wrapper">
        <span className="integration-title">{title}</span>
      </div>
      <div className="response-delete-button">
        <ButtonDelete
          setNodes={setNodes}
          setEdges={setEdges}
          nodeId={id}
          handleDelete={() => handleIntegrationIntentNode(updateIntent)}
        />
      </div>
    </div>
  );
};

export default IntegrationHeader;
